import { createApiClient } from 'lib/api/createApiClient';
import config from 'utils/config';

/** Shared `/v1` exchange API client for first-party web flows. */
export const exchangeApiV1 = createApiClient({ baseURL: `${config.exchangeApiUrl}/v1` });
